import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {AdxVccFilter, PaymentProvider} from '../../model/adx-data';
import {AdxVccPaymentProviderService} from '../../service/adx-vcc-payment-providers.service';
import {Observable, Subscription} from 'rxjs';
import {Merchant} from 'src/app/dashboard/model/merchant-guid';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';
import {AdxVccService} from '../../service/adx-vcc.service';
import {Router} from '@angular/router';

@AutoUnsubscribe()
@Component({
    selector: 'app-adx-vcc-filter',
    templateUrl: './adx-vcc-filter.component.html',
    standalone: false
})
export class AdxVccFilterComponent implements OnInit {
    @Input() config!:AdxVccFilter

    adxFilterForm!:FormGroup;
    disabled = false;
    paymentProviders$?: Observable<PaymentProvider[]>;
    merchantGuids: Merchant[] = [];

    breakPoint$?:Subscription;
    isSmall: boolean = false;

    constructor(
        @Optional() public adxDialogRef: MatDialogRef<AdxVccFilterComponent>,
        private adxVccPaymentProviders: AdxVccPaymentProviderService,
        private formBuilder:FormBuilder,
        private merchantsService: MerchantsService,
        private adxService: AdxVccService,
        private router: Router,
        breakpointObserver: BreakpointObserver,
    ){
        this.adxFilterForm = this.formBuilder.group<AdxVccFilter>({
            dateCreatedFrom:null,
            dateCreatedTo:null,
            paymentProvider:null,
            vccLastFourDigits:null,
            cardGuid:null,
            tripReference:null,
            cardStatus:null,
            merchantGuid: null,
        });

        this.breakPoint$ = breakpointObserver.observe([
            Breakpoints.Medium,
            Breakpoints.Small,
            Breakpoints.XSmall
        ]).subscribe(result => {
            this.isSmall = result.matches;
        });

        this.paymentProviders$ = this.adxVccPaymentProviders.getProviders();

     }

     form: FormGroup = new FormGroup({
         vccNumber: new FormControl('',[Validators.pattern(/^\d{4}$/), Validators.min(4)]),
       });
       

    ngOnInit(): void {
        this.adxService.getAdxFilter().subscribe((filter: AdxVccFilter) => {
            this.config = filter;
            
            this.adxFilterForm.patchValue(this.config || {});
            
            if (this.config?.cardGuid && typeof this.config.cardGuid === 'string') {
                this.adxFilterForm.get('cardGuid')?.setValue({ value: this.config.cardGuid });
            }
            
            if (this.config?.tripReference && typeof this.config.tripReference === 'string') {
                this.adxFilterForm.get('tripReference')?.setValue({ value: this.config.tripReference });
            }
        });
        this.merchantsService.merchants$.subscribe((data)=>{
            this.merchantGuids = data;
        });
    }

    applyAdxFilters(){
        this.config = this.adxFilterForm.value;
        this.config.vccLastFourDigits = this.config.vccLastFourDigits?.trim();
        
        if (this.config.cardGuid) {
            this.config.cardGuid = typeof this.config.cardGuid === 'object' 
                ? (this.config.cardGuid as any)?.value || (this.config.cardGuid as any)?.id || ''
                : this.config.cardGuid?.trim();
        }
        
        if (this.config.tripReference) {
            this.config.tripReference = typeof this.config.tripReference === 'object'
                ? (this.config.tripReference as any)?.value || (this.config.tripReference as any)?.id || ''
                : this.config.tripReference?.trim();
        }

        if (!this.config.cardGuid) {
            this.router.navigate(['/FinanceResources/AdxVcc'], {
                replaceUrl: true
            });
        }
        this.adxDialogRef.close(this.config);
    }

    handleBookingFiltersFormCloseEvent() {
        if (this.adxDialogRef) {
          this.adxDialogRef.close(null);
        }
      }

    clearAdxFields(...args:string[]){
        if(!args.length) {
            this.adxFilterForm.reset();
            return;
        }
        args.forEach((field)=>{
            this.adxFilterForm.controls[field].reset()
        })
    }

    validateCardNumberInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/\D/g, '');
        this.form.get('vccLastFourDigits')?.setValue(input.value);
      }
}
